import { createSlice } from "@reduxjs/toolkit";
import { fetchCruise } from "../thunks/fetchCruise"; // Make sure to import the fetchCruise thunk

const cruiseSlice = createSlice({
  name: "cruise",
  initialState: {
    cruise: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCruise.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCruise.fulfilled, (state, action) => {
        state.loading = false;
        state.cruise = action.payload;
      })
      .addCase(fetchCruise.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default cruiseSlice.reducer;
